module.exports = __webpack_public_path__ + "static/bg.3aa91b49.jpg";